import {Component, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material";
import {ProjectService} from "../../services/project.service";
import {NotificationService} from "../../services/notification.service";

@Component({
    selector: 'app-third-party-dialog',
    templateUrl: 'third-party-dialog.component.html',
})
export class ThirdPartyDialogComponent implements OnInit{
    public item: any;
    public id: string;
    public is_new: boolean;

    constructor(
        public dialogRef: MatDialogRef<ThirdPartyDialogComponent>,
        private projectServ: ProjectService,
        private notifServ: NotificationService
    ) {
    }

    ngOnInit(){
    }

    saveThridParty(){
        console.log('whatsapp')
        if(this.is_new){
            this.projectServ.addThirdParty(this.id, this.item).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( '3rd party entry has been added');
                }
            )
        }else{
            this.projectServ.updateThirdParty(this.id, this.item.key, this.item, true).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( '3rd party entry has been updated');
                }
            )
        }

    }

}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/third-party/third-party-dialog.component.ts